module.exports = __webpack_public_path__ + "assets/img/ynone.acf07a2d.png";